// extracted by mini-css-extract-plugin
module.exports = {"decor":"styles_decor__gm1T3","icon":"styles_icon__kYsYd"};